import { render, staticRenderFns } from "./prospectiveStudent.vue?vue&type=template&id=29241b46&scoped=true&"
import script from "./prospectiveStudent.vue?vue&type=script&lang=js&"
export * from "./prospectiveStudent.vue?vue&type=script&lang=js&"
import style0 from "./prospectiveStudent.vue?vue&type=style&index=0&id=29241b46&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29241b46",
  null
  
)

export default component.exports